import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Planzone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  updatePlanzoneContacts(
    request: Boundaries["updatePlanzoneContacts"]["request"],
  ): void;
}

function useUpdatePlanzoneContacts(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUpdatePlanzoneContactsRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUpdatePlanzoneContactsRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUpdatePlanzoneContactsRequestFailure(planzone),
    ),
    updatePlanzoneContacts: core.updatePlanzoneContacts,
  };
}

export { useUpdatePlanzoneContacts };
